import React, { useEffect, useState } from "react"; // Import useState
import { Link, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { connect } from "react-redux";
import { changeSidebarType } from "../../store/actions";

const SidebarContent = ({ changeSidebarType }) => {
  const location = useLocation();
  const [userRole, setUserRole] = useState(null); 

  const handleMenuClick = () => {
    // Check if we're on mobile (screen width <= 992px)
    if (window.innerWidth <= 992) {
      // Close sidebar by removing the sidebar-enable class
      document.body.classList.remove("sidebar-enable");
    }
  };

  useEffect(() => {
    const userString = localStorage.getItem("user");
    if (userString) {
      try {
        const user = JSON.parse(userString);
        const role = user?.role || user?.data?.role;
        setUserRole(role);
      } catch (error) {
        console.error("SidebarContent: Failed to parse user from localStorage", error);
        setUserRole(null); 
      }
    } else {
      setUserRole(null); 
    }
  }, []);

  const staffLinks = ["/video", "/ecommerce-products", "/ecommerce-categories", "/ecommerce-customers"];
  const subAdminLinks = ["/dashboard", "/ecommerce-orders", "/return", "/ecommerce-products", "/rate-cards", "/quantity-restrictions"];

  const isVisible = (link) => {
    if (!userRole) return false; 
    if (userRole === 'admin') return true; 
    if (userRole === 'staff') return staffLinks.includes(link);
    if (userRole === 'sub-admin') return true;
    return false; 
  };

  const isSubMenuVisible = (links) => {
    if (!userRole) return false;
    if (userRole === 'admin') return true;
    return links.some(link => isVisible(link));
  };

  useEffect(() => {
    if (!userRole) return; 
    let metisMenuInstance;
    const initMenu = () => {
      if (metisMenuInstance) {
        metisMenuInstance.dispose();
      }
      metisMenuInstance = new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (location.pathname === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };

    initMenu();

    return () => {
      if (metisMenuInstance) {
        metisMenuInstance.dispose();
      }
    };
  }, [location.pathname]);

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  }

  return (
    <React.Fragment>
      <SimpleBar
        style={{ maxHeight: "100%" }}
        className={"sidebar-menu-scroll"}
      >
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">Menu</li>
            {isVisible('/dashboard') && (
              <li>
                <Link to="/dashboard" className="waves-effect" onClick={handleMenuClick}>
                  <i className="ri-dashboard-line"></i>
                  <span>Dashboard</span>
                </Link>
              </li>
            )}

            {isSubMenuVisible([
              "/ecommerce-orders", "/return", "/ecommerce-customers", "/ecommerce-products",
              "/ecommerce-categories", "/ecommerce-coupons", "/ecommerce-brand",
              "/rate-cards", "/video", "/admin-settings", "/blogs", "/quantity-restrictions"
            ]) && (
              <li>
                <Link to="/#" className="has-arrow waves-effect">
                  <i className="ri-store-2-line"></i>
                  <span>Ecommerce</span>
                </Link>
                <ul className="sub-menu">
                  {isVisible('/ecommerce-orders') && <li><Link to="/ecommerce-orders" onClick={handleMenuClick}>Orders</Link></li>}
                  {isVisible('/return') && <li><Link to="/return" onClick={handleMenuClick}>Return Orders</Link></li>}
                  {isVisible('/ecommerce-customers') && <li><Link to="/ecommerce-customers" onClick={handleMenuClick}>Customers</Link></li>}
                  {isVisible('/ecommerce-products') && <li><Link to="/ecommerce-products" onClick={handleMenuClick}>Products</Link></li>}
                  {isVisible('/ecommerce-categories') && <li><Link to="/ecommerce-categories" onClick={handleMenuClick}>Categories</Link></li>}
                  {isVisible('/ecommerce-coupons') && <li><Link to="/ecommerce-coupons" onClick={handleMenuClick}>Coupons</Link></li>}
                  {isVisible('/ecommerce-brand') && <li><Link to="/ecommerce-brand" onClick={handleMenuClick}>Brands</Link></li>}
                  {isVisible('/rate-cards') && <li><Link to="/rate-cards" onClick={handleMenuClick}>Shipping Rate Cards</Link></li>}
                  {isVisible('/video') && <li><Link to="/video" onClick={handleMenuClick}>Videos List</Link></li>}
                  {isVisible('/notification') && <li><Link to="/notification" onClick={handleMenuClick}>Notification</Link></li>}
                  {isVisible('/admin-settings') && <li><Link to="/admin-settings" onClick={handleMenuClick}>Admin Settings</Link></li>}
                  {isVisible('/blogs') && <li><Link to="/blogs" onClick={handleMenuClick}>Blogs</Link></li>}
                  {isVisible('/quantity-restrictions') && <li><Link to="/quantity-restrictions" onClick={handleMenuClick}>Quantity Restrictions</Link></li>}
                </ul>
              </li>
            )}

            {userRole === 'admin' || userRole === 'sub-admin' && (
              <li>
                <Link to="/contact-us" className="waves-effect" onClick={handleMenuClick}>
                  <i className="ri-contacts-line"></i>
                  <span>Contact Us</span>
                </Link>
              </li>
            )}

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

export default connect(null, { changeSidebarType })(SidebarContent);
